import {PlayCircleOutlined} from "@ant-design/icons";
import React from "react";
import {connect} from "react-redux";
import {showUploadOverlay} from "../../../store/actions/layout";
import {ShowUploadOverlayAction} from "../../../interfaces/store/actions/layout";
import StoreState from "../../../interfaces/store/storeState";

interface OwnProps {
    videoUrl: string
    playable: boolean
}
interface DispatchProps {
    showUploadOverlay(payload: boolean) : ShowUploadOverlayAction
}
interface StateProps {
    videoPlaying: boolean
}
type Props = OwnProps & DispatchProps & StateProps;
class VideoThumbnail extends React.Component<Props> {
    private player: React.RefObject<HTMLVideoElement> = React.createRef<HTMLVideoElement>();

    private pausedAt: number = 0;

    constructor(props: Props) {
        super(props);
        this.onClickHandler = this.onClickHandler.bind(this);
        this.onVideoEndHandler = this.onVideoEndHandler.bind(this);
        this.onPauseHandler = this.onPauseHandler.bind(this);
    }

    onClickHandler(): void {
        this.props.showUploadOverlay(false);
    }

    onVideoEndHandler(): void {
        this.pausedAt = 0;
        this.props.showUploadOverlay(true);
    }

    onPauseHandler(): void {
        if (this.player.current?.readyState === 4) {
            this.props.showUploadOverlay(true);
            this.pausedAt = this.player.current?.currentTime;
        }
    }

    render(): React.ReactNode {
        const { playable, videoUrl, videoPlaying}: Props = this.props;
        return (
            <div className="df-thumbnail-video">
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video
                    ref={this.player}
                    preload="metadata"
                    autoPlay={videoPlaying}
                    src={`${videoUrl}#t=${this.pausedAt}`}
                    controls={videoPlaying}
                    onEnded={this.onVideoEndHandler}
                    onPause={this.onPauseHandler}
                />
                {
                    playable && !videoPlaying && (
                        <div className="df-thumbnail-mask">
                            <div className="df-icon-play">
                                <PlayCircleOutlined onClick={this.onClickHandler}/>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}

function mapStateToProps({
    layout: {
        filePicker: {
            showOverlay,
        },
    },
}: StoreState): StateProps {
    return {
        videoPlaying: !showOverlay,
    };
}

const mapDispatchToProps = {
    showUploadOverlay,
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoThumbnail);
